module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("A Year of Biblical Womanhood")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ctmi",
    staticStyle: {
      "margin-top": "15%"
    },
    attrs: {
      "id": "p0011-01-0"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "pagexi"
    }
  }, [_c('b', [_vm._v("Contents")])])])]), _c('a', {
    attrs: {
      "id": "pagexi"
    }
  }, [_c('hr', {
    staticStyle: {
      "color": "#cecece",
      "border": "thick solid"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', [_c('br'), _c('br')])])]), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "id": "pagexi"
    }
  }, [_c('span')]), _c('span', {
    attrs: {
      "href": "#/letter#cc0",
      "id": "c1a",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("A Letter to Friends")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0011-02-1"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/chapter5#cc1",
      "id": "c1"
    }
  }, [_c('i', [_vm._v("Introduction")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0011-03-2"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/chapter7#cc2",
      "id": "c2"
    }
  }, [_vm._v("October: Gentleness—Girl Gone Mild")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0011-P-1"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter9#cc3",
      "id": "c3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("November: Domesticity—Martha, Martha")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0011-P-2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter11#cc4",
      "id": "c4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("December: Obedience—My Husband, My Master")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0011-P-3"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter13#cc5",
      "id": "c5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("January: Valor—Will the "), _c('i', [_vm._v("Real")]), _vm._v(" Proverbs 31 Woman Please Stand Up?")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0011-P-4"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter15#cc6",
      "id": "c6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("February: Beauty—My Breasts Are Like Towers")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0011-P-5"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter17#cc7",
      "id": "c7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("March: Modesty—Hula-Hooping with the Amish")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0011-P-6"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter19#cc8",
      "id": "c8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("April: Purity—The Worst Time of the Month to Go Camping")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0011-P-7"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter21#cc9",
      "id": "c9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("May: Fertility—Quivers Full of Arrows and Sippy Cups")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0011-P-8"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter23#cc10",
      "id": "c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("June: Submission—A Disposition to Yield")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0011-P-9"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter25#cc11",
      "id": "c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("July: Justice—Eat More Guinea Pig")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0011-P-10"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter27#cc12",
      "id": "c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("August: Silence—I Am Woman, Hear Me No More")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0011-P-11"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter29#cc13",
      "id": "c13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("September: Grace—Days of Awe")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0011-P-12"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter30#cc14",
      "id": "c14",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0011-P-13"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter31#cc15",
      "id": "c15",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0011-P-14"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter32#cc16",
      "id": "c16",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/excerpt#cc17",
      "id": "c17",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("An excerpt from")]), _vm._v(" Searching for Sunday")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6044f85c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter3.vue
// module id = 75
// module chunks = 0